import { IP_V4_REGEXP } from '@/common/utils/validate';

export default {
  getProps: state => state.props,
  getDomainLinks: (state, getters, rootState, rootGetters) => (domain) => {
    const endpointHostname = rootGetters['compute/hostname'];
    const sspPort = rootGetters['compute/selfservicePanelPort'];
    const portPostfix = sspPort === 80 ? '' : `:${sspPort}`;

    if (endpointHostname && !IP_V4_REGEXP.test(endpointHostname)) {
      return [encodeURI(`https://${endpointHostname}${portPostfix}/login/${domain}`)];
    }

    const selfserviceLocations = rootGetters['ha/selfserviceLocations'];
    const primaryNode = rootGetters['locations/primaryNode'];
    const sspLinks = primaryNode?.ipAddresses?.selfservice?.filter(ip => IP_V4_REGEXP.test(ip))
      .map(ip => encodeURI(`https://${ip}${portPostfix}/login/${domain}`));

    const haSspLinks = selfserviceLocations?.length && selfserviceLocations.map(location => encodeURI(`${location}/login/${domain}`));
    return haSspLinks || sspLinks || [];
  },
  getNameOrId: (_state, getters) => id => getters.getItemById(id)?.name || id,
  getDomainIdPLinks: (_, getters) => (domain, idp) => getters
    .getDomainLinks(domain)
    .map(link => `${link}/${idp}`)
};
